import { createAction } from "@ngrx/store";

import { CasinoBlockUpdate } from "./casino-block.model";

export namespace CasinoBlockAction {
	const ACTION_PREFIX = "[Casino Block]";

	export const update = createAction(`${ACTION_PREFIX} Update`, (casinoBlockUpdate: CasinoBlockUpdate) => ({
		casinoBlockUpdate,
	}));

	export const postpone = createAction(`${ACTION_PREFIX} Postpone`);
	export const clear = createAction(`${ACTION_PREFIX} Clear`);
}
